import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { useFormik } from "formik";
import * as Yup from "yup";
import { loginUser } from "../../../slices/thunks";

export const useLogin = (navigate: any) => {
    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            user: state.Login.user,
            error: state.Login.error,
            loading: state.Login.loading,
        })
    );

    const { user, error, loading } = useSelector(loginpageData);

    const [userLogin, setUserLogin] = useState<any>({ document: "", password: "" });
    const [passwordShow, setPasswordShow] = useState<boolean>(false);

    useEffect(() => {
        if (user && Object.keys(user).length > 0) {
            setUserLogin({
                document: user.email || user.document || "",
                password: user.confirm_password || ""
            });
        }
    }, [user]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            document: userLogin.document || '',
            password: userLogin.password || '',
        },
        validationSchema: Yup.object({
            document: Yup.string()
                .required("El documento es obligatorio"),
            password: Yup.string()
                .required("La contraseña es obligatoria"),
        }),
        onSubmit: (values) => {
            dispatch(loginUser({ user: values, history: navigate }));
        }
    });

    const togglePasswordVisibility = () => setPasswordShow(!passwordShow);

    return {
        validation,
        error,
        loading,
        passwordShow,
        togglePasswordVisibility,
    };
};
